<cache-date></cache-date>

<period></period>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<ng-container *ngFor="let chartData of charts">
	<div class="row">
		<div class="col-md-12">
			<chart [data]="chartData.data" [options]="chartData.options" [sextant]="'chart-' + chartData.name"></chart>
		</div>
	</div>
	
	<hr><br>
</ng-container>

<loading [isLoad]="chartLoader"></loading>

<loading [isLoad]="listLoader"></loading>
<table class="table" *ngIf="!listLoader">
	<thead>
		<tr>
			<th>{{ 'adminstat.widget.widget' | translate }}</th>
			<th>{{ 'adminstat.widget.category' | translate }}</th>
			<th>{{ 'adminstat.widget.number of additions' | translate }}</th>
			<th>{{ 'adminstat.widget.percent from total number of additions' | translate }}</th>
		</tr>
	</thead>

	<tbody>
		<tr *ngIf="countLoader">
			<td colspan="4">
				<div [sextant]="'widget-progress-bar'" class="progress-bar progress-bar-striped progress-bar-animated" [ngStyle]="{'width': (stats.length / (widgetList.length / 100)) + '%'}">
					<ng-container *ngIf="stats.length > 5">
						{{ widgetList[stats.length] }} loading
					</ng-container>
					...
				</div>
			</td>
		</tr>
		
		<tr *ngFor="let stat of stats" [sextant]="'widgetInfo'" [url]="filter.currentUrl">
			<td>
				<ng-container *ngIf="stat.widgetName == 'googleCounter' || stat.widgetName == 'yandexCounter'">
					{{ stat.widgetName }}
				</ng-container>
				
				<ng-container *ngIf="stat.widgetName != 'googleCounter' && stat.widgetName != 'yandexCounter'">
					{{ stat.widgetName }} - {{ 'widgets.' + stat.widgetName + '.name' | translate }}
				</ng-container>
				
				<ng-container *ngIf="oldWidgets.includes(stat.widgetName)">
					old
				</ng-container>
			</td>
			
			<td>
				{{ 'adminstat.site.widget.' + stat.widgetGroup | translate }}
			</td>
			
			<td>
				{{ stat.widgetAddCount }}
			</td>
			
			<td>
				{{ helper.percentageFormat(stat.widgetAddCount / totalCount) }}
			</td>
		</tr>
	</tbody>
</table>

<br><br>

